
// パスワード表示、非表示
$('.password_eyes').on('click', function () {
    let password_view = $(".password_view");
    let password_eyes = $(".password_eyes");

    if (password_view.attr('type') == "text") {
        password_view.attr("type", "password");
        password_eyes.text("表示");
    } else {
        password_view.attr("type", "text");
        password_eyes.text("非表示");
    }
});